import { PLAYER, EVENT } from "@/lib/content";
import { Trophy, Users, MapPin, Calendar } from "lucide-react";

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="relative scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.35em] text-[#FF007F]">
            The mission
          </div>
          <h2 className="font-display uppercase tracking-tight text-5xl md:text-6xl mt-3 leading-[0.9]">
            One tournament.<br /> One <span className="text-[#FACC15]">summer.</span><br /> One <span className="text-[#00E5FF]">shot.</span>
          </h2>
        </div>
        <div className="md:col-span-8 space-y-6 text-lg text-[#D4D4D8] font-light leading-relaxed">
          <p>{PLAYER.longBio}</p>

          {/* Event spotlight card */}
          <div className="border border-[#27272A] bg-[#0B0B0D] p-6 md:p-8">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#FACC15]">
              The Event
            </div>
            <div className="font-display text-3xl md:text-4xl uppercase tracking-tight mt-2 text-white">
              {EVENT.fullName}
            </div>
            <div className="text-[#A1A1AA] text-base mt-2">
              Hosted by {EVENT.hostedBy} • a.k.a. <span className="text-[#FF007F] font-semibold">{EVENT.shortName}</span>
            </div>
            <p className="text-[#D4D4D8] mt-4 font-light">{EVENT.description}</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-[#27272A]">
              <div className="flex items-start gap-2">
                <Calendar className="h-4 w-4 text-[#00E5FF] mt-1" />
                <div>
                  <div className="text-[9px] uppercase tracking-[0.25em] text-[#71717A]">Dates</div>
                  <div className="text-white font-semibold text-sm">{EVENT.dates}</div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-[#FF007F] mt-1" />
                <div>
                  <div className="text-[9px] uppercase tracking-[0.25em] text-[#71717A]">Location</div>
                  <div className="text-white font-semibold text-sm">{EVENT.city}</div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Trophy className="h-4 w-4 text-[#FACC15] mt-1" />
                <div>
                  <div className="text-[9px] uppercase tracking-[0.25em] text-[#71717A]">Format</div>
                  <div className="text-white font-semibold text-sm">29 courts • 4-game guarantee</div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Users className="h-4 w-4 text-[#A78BFA] mt-1" />
                <div>
                  <div className="text-[9px] uppercase tracking-[0.25em] text-[#71717A]">Eligible</div>
                  <div className="text-white font-semibold text-sm">Native, PI, Native Hawaiian</div>
                </div>
              </div>
            </div>
          </div>

          <p>
            Tournament entry. Travel from home to Mesa. Four nights in a hotel. Gear, food
            and per-diem for the trip. It all adds up faster than the scoreboard at a
            Wookies game. We're asking you to be a small part of getting #10 on that
            court.
          </p>
          <div className="pt-4 border-t border-[#27272A] grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Age</div>
              <div className="font-display text-3xl">{PLAYER.age}</div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Position</div>
              <div className="font-display text-3xl">PG</div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Jersey</div>
              <div className="font-display text-3xl text-[#FF007F]">#{PLAYER.jersey}</div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#71717A]">Team</div>
              <div className="font-display text-3xl text-[#00E5FF]">{PLAYER.team}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
